/**
 * Platform detection helpers for OS-aware keyboard shortcuts.
 */

/**
 * Whether the user is on an Apple platform (macOS/iOS), where the
 * primary shortcut modifier is Command (⌘) instead of Ctrl.
 *
 * @returns {boolean}
 */
export function isMacPlatform() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const platform = navigator.userAgentData?.platform || navigator.platform || '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/**
 * Whether the platform's primary shortcut modifier (⌘ on Mac, Ctrl elsewhere)
 * is held for this keyboard event. Accepts either modifier so shortcuts keep
 * working for users on remapped or cross-platform keyboards.
 *
 * @param {KeyboardEvent} event
 * @returns {boolean}
 */
export function isModKeyPressed(event) {
  return Boolean(event && (event.metaKey || event.ctrlKey));
}
